// Opening Balance Getters

export const getOpeningBalanceInfo = state => {
  return state.openingBalanceInfo
}
